import { SchemaField } from '../../../generic/serialization/schema-field';
import { jsonStringSchema } from '../../../generic/serialization/schema-field/json-string-schema/json-string-schema';
import { SerializableObjectSchema } from '../../../generic/serialization/serializable-object-schema';

export class RedisLockSchema extends SerializableObjectSchema {
  public static readonly token = 'token';

  public static readonly acquiredBy = 'acquiredBy';

  public static readonly acquiredAt = 'acquiredAt';

  public static readonly expiresAt = 'expiresAt';

  public static readonly value = 'value';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly token = undefined;

    public static readonly acquiredBy = undefined;

    public static readonly acquiredAt = undefined;

    public static readonly expiresAt = undefined;

    public static readonly value = undefined;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = {} as any;

    /* eslint-disable */
    parameters[RedisLockSchema.token] = SchemaField.string(RedisLockSchema.Defaults.token).required();
    parameters[RedisLockSchema.acquiredBy] = SchemaField.string(RedisLockSchema.Defaults.acquiredBy).required();
    parameters[RedisLockSchema.acquiredAt] = SchemaField.timestamp(RedisLockSchema.Defaults.acquiredAt).required();
    parameters[RedisLockSchema.expiresAt] = SchemaField.timestamp(RedisLockSchema.Defaults.expiresAt).required();
    parameters[RedisLockSchema.value] = jsonStringSchema(RedisLockSchema.Defaults.value);
    /* eslint-enable */

    return parameters;
  }
}
